module.exports = __webpack_public_path__ + "img/key.4b1230c5.svg";